import {
  CarePlanNoteInterventionResponse,
  CarePlanNoteResponse,
} from '~/lib/types/carePlan/carePlans';
import { useMemo } from 'react';
import { CarePlanInterventionStatus } from '~/lib/types/carePlan/CarePlanInterventionStatus';

export const useFilteredCarePlanNoteInterventions = (
  carePlan: CarePlanNoteResponse,
) => {
  return useMemo(() => {
    const interventionsFromGoals = carePlan.problems
      .flatMap((problem) => problem.goals)
      .flatMap((goal) => goal.interventions);

    const uniqueInterventionsMap: Record<
      string,
      CarePlanNoteInterventionResponse
    > = [
      ...interventionsFromGoals,
      ...carePlan.foundationalInterventions,
    ].reduce((acc, curr) => {
      if (!acc[curr.id]) {
        acc[curr.id] = curr;
      }
      return acc;
    }, {});

    const allInterventions = Object.values(uniqueInterventionsMap);

    // The BE filters by provider role. VOID is kept as a fail-safe — a voided
    // intervention must never surface in a clinical note.
    const filteredInterventions = allInterventions.filter(
      (intervention) =>
        intervention.status.code !== CarePlanInterventionStatus.VOID,
    );

    // Customs have no catalog sortOrder, so they sort last, by description.
    return filteredInterventions.sort((i1, i2) => {
      if (!i1.intervention && !i2.intervention) {
        return (i1.description ?? '').localeCompare(i2.description ?? '');
      }
      return (
        (i1.intervention?.sortOrder ?? Infinity) -
        (i2.intervention?.sortOrder ?? Infinity)
      );
    });
  }, [carePlan]);
};
